(() => {
  const storageKey = 'bsk_offer_journey_v1';
  const cartContext = window.BskLocalOfferCart;
  const surface = document.querySelector('[data-bsk-offer]');
  if (!cartContext || !surface) return;
  const reference = (item) => String(item.properties?._bsk_ref || item.properties?._bsk_bundle_id || '').split(':')[0];
  const browseUrl = new URL(surface.dataset.catalogUrl, location.origin);
  browseUrl.searchParams.set('bsk_offer', 'second');
  const isBrowse = location.pathname.replace(/\/$/, '') === browseUrl.pathname.replace(/\/$/, '') && new URL(location.href).searchParams.get('bsk_offer') === 'second';
  let saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
  let activeCart = null;
  let parent = null;
  let panel = null;
  let productRoot = null;
  let catalog = null;
  let generation = 0;
  const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: activeCart?.currency || saved?.currency || 'TRY' }).format(Number(value || 0) / 100);
  const eligibleTitle = (title) => /fincan|kupa/.test(String(title).toLocaleLowerCase('tr-TR')) && !/takım|seti|ikili/.test(String(title).toLocaleLowerCase('tr-TR'));
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const putSaved = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {} };
  const clear = () => {
    saved = null;
    parent = null;
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
    document.querySelectorAll('[data-bsk-journey-product]').forEach((root) => {
      delete root.dataset.bskOfferProduct;
      delete root.dataset.bskOfferParent;
      delete root.dataset.bskJourneyProduct;
    });
    panel?.remove();
    panel = null;
  };
  const activate = (group, cart) => {
    saved = { parent: reference(group.lead), token: String(cart.token || '').split('?')[0], currency: cart.currency || 'TRY' };
    parent = group.lead;
    activeCart = cart;
    putSaved();
  };
  const refresh = async () => {
    if (!saved) return false;
    const cartUrl = `${(window.routes?.cart_url || '/cart').replace(/\/$/, '')}.js`;
    const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    const lead = cart.items?.find((item) => reference(item) === saved.parent && !String(item.properties?._bsk_ref || '').includes(':A'));
    if (!lead || String(cart.token || '').split('?')[0] !== saved.token || !window.BskSecondCupOffer.canOffer(lead, cart)) {
      clear();
      return false;
    }
    activeCart = cart;
    parent = lead;
    return true;
  };
  const savingFor = (price) => Math.round(Math.min(Number(parent.final_price ?? parent.price ?? 0), Number(price || 0)) * .2);
  const cartButton = () => {
    const button = make('button', 'bsk-journey__back', 'Sepetime dön');
    button.type = 'button';
    button.addEventListener('click', () => { void window.BskSecondCupOffer.showCart(cartContext, button); });
    return button;
  };
  const renderPdp = () => {
    const root = document.querySelector('[data-bsk-product]:not([data-bsk-second-product])');
    if (!root || !parent || !eligibleTitle(root.querySelector('h1')?.textContent) || root.dataset.bskPdpProfile === 'helper') return;
    const form = root.querySelector('[data-bsk-product-form]');
    if (!form) return;
    productRoot = root;
    if (!panel?.isConnected) {
      panel = make('aside', 'bsk-journey bsk-journey--pdp');
      panel.setAttribute('aria-label', 'İkinci ürün teklifin');
      panel.innerHTML = '<p class="bsk-journey__eyebrow">İKİNCİ FİNCAN TEKLİFİN</p><strong class="bsk-journey__benefit" data-bsk-journey-saving></strong><p class="bsk-journey__context" data-bsk-journey-context></p><div class="bsk-journey__total"><span>Bu ürünle sepet toplamın</span><strong data-bsk-journey-total></strong></div><p class="bsk-journey__terms">İki ana üründen uygun fiyatlı olana %20 indirim. Paket ve ek işlemler tam fiyat.</p>';
      const actions = make('div', 'bsk-journey__links');
      const alternatives = make('a', '', 'Diğer modelleri incele');
      alternatives.href = browseUrl.href;
      actions.append(alternatives, cartButton());
      panel.append(actions);
      form.prepend(panel);
    }
    const id = Number(root.querySelector('[data-bsk-variant-id]')?.value || 0);
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-bsk-product-variants]')?.textContent || '[]'); } catch (_) {}
    const variant = variants.find((item) => Number(item.id) === id);
    const base = Number(root.dataset.bskBasePrice || 0);
    const extras = Array.from(root.querySelectorAll('[data-bsk-addon-variant-id]:checked')).filter((input) => !input.disabled).reduce((sum, input) => sum + Number(input.dataset.bskAddonPrice || 0), 0);
    const saving = savingFor(base);
    const valid = Boolean(variant?.available && base > 0);
    panel.querySelector('[data-bsk-journey-saving]').textContent = valid ? `Bu ikiliyle ${money(saving)} tasarruf` : 'Uygun bir ürün seçeneği belirle';
    panel.querySelector('[data-bsk-journey-context]').textContent = `Sepetindeki ${parent.product_title || parent.title} ve bu ürün için.`;
    panel.querySelector('[data-bsk-journey-total]').textContent = valid ? money(Number(activeCart.total_price) + base + extras - saving) : 'Seçimine göre hesaplanır';
  };
  const mountCatalog = () => {
    const main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!main) return;
    Array.from(main.children).forEach((child) => { child.hidden = true; });
    const shell = make('section', 'bsk-journey bsk-journey--catalog');
    shell.dataset.bskJourneyCatalog = '';
    const header = make('header', 'bsk-journey__header');
    header.append(make('p', 'bsk-journey__eyebrow', 'İKİNCİ FİNCANINI KEŞFET'), make('h1', '', 'Önce incele. Sonra ikilini tamamla.'), make('p', 'bsk-journey__intro', 'Görselleri, hacmi ve tüm seçenekleri ürün sayfasında incele. Seçtiğinde ikilinin uygun fiyatlı ürününe %20 indirim uygulanır.'));
    const first = make('div', 'bsk-journey__first');
    first.append(make('span', '', `Sepetindeki ürün: ${parent?.product_title || parent?.title || 'Teklif kontrol ediliyor'}`), cartButton());
    const list = make('div', 'bsk-journey__grid');
    const status = make('p', 'bsk-journey__status', 'Ürünler yükleniyor…');
    status.setAttribute('role', 'status');
    const more = make('button', 'bsk-journey__more', 'Daha fazla model gör');
    more.type = 'button';
    header.append(first);
    shell.append(header, list, status, more);
    main.append(shell);
    catalog = { shell, list, status, more, page: 1, products: new Set(), loading: false };
    more.addEventListener('click', () => { void loadCatalog(); });
  };
  const loadCatalog = async () => {
    if (!catalog || catalog.loading || catalog.page === null || !parent) return;
    const view = catalog;
    view.loading = true;
    view.more.disabled = true;
    view.list.setAttribute('aria-busy', 'true');
    view.status.textContent = 'Stoktaki uygun fincan ve kupalar yükleniyor.';
    try {
      let added = 0;
      let requests = 0;
      while (view.page !== null && added < 6 && requests < 3) {
        const url = new URL(browseUrl);
        url.searchParams.delete('bsk_offer');
        url.searchParams.set('section_id', 'bsk-offer-products');
        url.searchParams.set('page', view.page);
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Catalog unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(doc.querySelector('[data-bsk-offer-catalog]')?.textContent || 'null');
        if (!Array.isArray(data?.products)) throw new Error('Catalog missing');
        data.products.forEach((product) => {
          if (view.products.has(String(product.id)) || !product.available) return;
          const url = new URL(product.url, location.origin);
          if (url.origin !== location.origin) return;
          url.searchParams.set('bsk_offer', 'second');
          url.searchParams.set('variant', product.variant_id);
          const link = make('a', 'bsk-journey__card');
          link.href = url.href;
          const image = make('img', '');
          if (product.image) image.src = product.image;
          image.alt = product.title;
          image.width = 600;
          image.height = 600;
          image.loading = 'lazy';
          const body = make('div', 'bsk-journey__card-body');
          body.append(make('h2', '', product.title), make('p', 'bsk-journey__card-price', money(product.price)), make('p', 'bsk-journey__card-saving', `Bu ikiliyle ${money(savingFor(product.price))} tasarruf`), make('span', 'bsk-journey__inspect', 'İncele ve seç →'));
          link.append(image, body);
          view.list.append(link);
          view.products.add(String(product.id));
          added += 1;
        });
        const next = Number(data.next_page);
        view.page = Number.isInteger(next) && next > view.page ? next : null;
        requests += 1;
      }
      view.status.textContent = view.products.size ? 'Paket ve ek işlemler indirime dahil değildir. Kesin toplam ürün sayfasındaki seçimine göre hesaplanır.' : 'Şu an uygun bir model bulunamadı. Sepetindeki ürün korunuyor.';
      view.more.hidden = view.page === null;
      view.more.textContent = 'Daha fazla model gör';
    } catch (_) {
      view.status.textContent = 'Modeller yüklenemedi. Tekrar deneyebilir veya sepetine dönebilirsin.';
      view.more.textContent = 'Tekrar dene';
      view.more.hidden = false;
    } finally {
      view.loading = false;
      view.more.disabled = false;
      view.list.removeAttribute('aria-busy');
    }
  };
  const invalidateCatalog = (message) => {
    if (!catalog) return;
    catalog.list.hidden = true;
    catalog.more.hidden = true;
    catalog.status.textContent = message;
    catalog.shell.querySelector('.bsk-journey__intro').textContent = 'Sepetini kontrol ederek alışverişine devam edebilirsin.';
  };
  const restore = async () => {
    const revision = ++generation;
    try {
      const valid = await refresh();
      if (revision !== generation) return;
      if (isBrowse) {
        if (!catalog) mountCatalog();
        if (!valid) { invalidateCatalog('Bu teklif için sepette bir uygun fincan veya kupa olmalı. İlk ürün kaldırılmış veya ikili zaten tamamlanmış olabilir.'); return; }
        catalog.list.hidden = false;
        catalog.shell.querySelector('.bsk-journey__first>span').textContent = `Sepetindeki ürün: ${parent.product_title || parent.title}`;
        if (!catalog.products.size) void loadCatalog();
      } else if (valid) renderPdp();
    } catch (_) {
      if (isBrowse) {
        if (!catalog) mountCatalog();
        invalidateCatalog('Teklif şu an doğrulanamadı. Sayfayı yenileyebilir veya sepetine dönebilirsin.');
      }
    }
  };
  window.BskOfferJourney = {
    activate, clear,
    cartChanged(cart) {
      if (!saved) return;
      const lead = cart.items?.find((item) => reference(item) === saved.parent && !String(item.properties?._bsk_ref || '').includes(':A'));
      if (!lead || String(cart.token || '').split('?')[0] !== saved.token || !window.BskSecondCupOffer.canOffer(lead, cart)) {
        clear();
        invalidateCatalog('Sepet içeriğin değiştiği için teklif güncellendi. Bu teklif için sepette bir uygun fincan veya kupa olmalı.');
        return;
      }
      activeCart = cart;
      parent = lead;
      renderPdp();
    },
    browse() { location.assign(browseUrl.href); },
    async prepareAdd(root) {
      if (root.hasAttribute('data-bsk-second-product')) return true;
      delete root.dataset.bskOfferProduct;
      delete root.dataset.bskOfferParent;
      delete root.dataset.bskJourneyProduct;
      if (!saved) return true;
      try {
        if (!await refresh()) return true;
      } catch (_) {
        root.querySelectorAll('[data-bsk-product-message]').forEach((message) => { message.textContent = 'Teklif doğrulanamadı. Seçimlerin korundu; lütfen tekrar dene.'; });
        return false;
      }
      const quantity = Number(root.querySelector('[name="quantity"]')?.value || 1);
      if (!eligibleTitle(root.querySelector('h1')?.textContent) || root.dataset.bskPdpProfile === 'helper' || quantity !== 1) return true;
      root.dataset.bskOfferProduct = '';
      root.dataset.bskOfferParent = reference(parent);
      root.dataset.bskJourneyProduct = '';
      return true;
    }
  };
  document.addEventListener('change', (event) => { if (event.target.closest('[data-bsk-product]') === productRoot) queueMicrotask(renderPdp); });
  document.addEventListener('click', (event) => { if (event.target.closest('[data-bsk-letter]')?.closest('[data-bsk-product]') === productRoot) requestAnimationFrame(renderPdp); });
  window.addEventListener('pageshow', (event) => { if (event.persisted) { try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {} void restore(); } });
  window.addEventListener('focus', () => { if (saved && !document.querySelector('[data-bsk-offer][open]')) void restore(); });
  if (saved || isBrowse) void restore();
})();
